<template lang="pug">
  div(class="block-welcome-premium")
    div(class="block-welcome-premium__image")
      v-img(
        :src="require('~/assets/images/dubidoc-premium-bg.png')"
        max-width="100%"
        height="200"
      )
    div(class="block-welcome-premium__content")
      h2(class="title-32px bold") {{ $t('Among all of them, we chose you!') }}
      div(class="text-16px") {{ $t('Get free access to advanced Dubidoc Premium features') }}
      div(class="block-welcome-premium__features")
        div(
          v-for="(feature, idx) in features"
          :key="idx"
          class="block-welcome-premium__feature"
        )
          e-svg-icon check-black
          span(class="text-12px") {{ feature }}
      div(class="block-welcome-premium__promo")
        div(class="block-welcome-premium__promo-image")
          div 🎁
        div
          div(class="text-16px dark") {{ $t('Free during beta testing') }}
          div(class="text-14px") {{ $t('No cards. No obligations') }}
      div(class="two-buttons-wrapper pt-8")
        v-btn(
          height="48"
          @click="handleClose"
        ) {{ $t('Remind later') }}
        a(
          class="main-button block-welcome-premium__btn"
          href="https://docs.google.com/forms/d/e/1FAIpQLSc8HpONg_CAcMObYksFyczJdwoQ3R-g3ihEsHsTasJbPHqgsg/viewform"
          target="_blank"
        ) {{ $t('Get access') }}
</template>

<script>
export default {
  name: 'MBlockWelcomePremium',
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    features() {
      return [
        '100 вихідних документів на місяць',
        'Погодження документів',
        'Структурована система папок',
        'База контрагентів для швидкої роботи',
        'Віджет документу до вашого сервісу',
        'Коментування та обговорення'
      ]
    }
  },
  methods: {
    handleClose() {
      this.$setLocalStorageClientData({ showPremiumWelcome: false })
      this.closeModal()
    }
  }
}
</script>

<style scoped lang="scss">
.block-welcome-premium {
  &__image {
    position: relative;
    display: flex;
    justify-content: center;
    background: linear-gradient(91deg, #fff -29.58%, #f8e3f4 66.15%);

    &-folder {
      position: absolute;
      top: 38px;
      left: 46px;
      z-index: map-get($zIndexes, 'base');
      transform: rotateZ(25deg);
      max-width: 48px;
      width: 100%;
      height: auto;
    }
    &-box {
      position: absolute;
      top: 86px;
      right: 26px;
      z-index: map-get($zIndexes, 'base');
      transform: rotateZ(-25deg);
    }
  }
  &__content {
    padding: 32px 40px 40px 40px;
  }
  &__features {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;

    padding: 24px 0;
  }
  &__feature {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  &__promo {
    padding: 14px 16px;
    border-radius: 12px;
    background: $primary-light;

    display: flex;
    align-items: center;
    gap: 12px;

    &-image {
      border-radius: 50%;
      width: 40px;
      height: 40px;

      display: flex;
      align-items: center;
      justify-content: center;
      background: #f2e5ef;
    }
  }
  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-decoration: none;
    font-weight: 500 !important;
  }
}
</style>
